import { Navigate, Route } from "react-router-dom";
import { ReactNode } from "react";
import TopPage from "./TopPage";
import { PageContext } from "./PageContext";
import IssuancePage from "./IssuancePage/IssuancePage";
import { HeaderTitleProvider } from "../../components/Header";
import CarryOutPage from "./CarryOutPage/CarryOutPage";
import CarryInPage from "./CarryInPage/CarryInPage";
import ConstructionPlanPage from "./ConstructionPlanPage/ConstructionPlanPage";
import MaterialSearchPage from "./MaterialSearchPage/MaterialSearchPage";
import CachePage from "./SetingPages/CachePage/CachePage";
import SettingListPage from "./SetingPages/SettingListPage";
import MasterListPage from "./MasterPages/MasterListPage";
import MasterViewPage from "./MasterPages/MasterViewPage";
import WorkMasterPage from "./MasterPages/WorkMasterPage";
import ReportListPage from "./ReportListPage/ReportListPage";
import ConstructionExecutePage from "./ConstructionExecutePage";
import StockPage from "./StockPage/StockPage";
import QuantityPlanPage from "./QuantityPlanPage";

type Page = {
  name: string;
  path: string;
  main: (context: PageContext) => ReactNode;
};

export function GetRoutes(context: PageContext) {
  const pages: Page[] = [
    // 通常業務ページ
    { name: "機能一覧", path: "/", main: (context) => <TopPage pageContext={context} /> },
    { name: "発行", path: "issuance/", main: (context) => <IssuancePage pageContext={context} /> },
    { name: "出荷", path: "carry-out/", main: (context) => <CarryOutPage pageContext={context} /> },
    { name: "工事マスタ", path: "work-master/", main: (context) => <WorkMasterPage pageContext={context} /> },
    { name: "マスタ閲覧", path: "master-view/", main: (context) => <MasterViewPage pageContext={context} /> },
    { name: "施工実施", path: "construction-execute/", main: (context) => <ConstructionExecutePage pageContext={context} /> },
    { name: "搬入", path: "carry-in/", main: (context) => <CarryInPage pageContext={context} /> },
    { name: "施工", path: "construction-plan/", main: (context) => <ConstructionPlanPage pageContext={context} /> },
    { name: "在庫", path: "stock/", main: (context) => <StockPage pageContext={context} /> },
    { name: "数量計画", path: "quantity-plan/", main: (context) => <QuantityPlanPage pageContext={context} /> },
    { name: "材料検索", path: "search-materials/", main: (context) => <MaterialSearchPage pageContext={context} /> },

    // 業務管理ページ
    { name: "帳票出力", path: "reports/", main: (context) => <ReportListPage pageContext={context} /> },
    { name: "マスター編集", path: "masters/", main: (context) => <MasterListPage pageContext={context} /> },
    { name: "設定一覧", path: "settings/", main: (context) => <SettingListPage pageContext={context} /> },
    { name: "キャッシュ", path: "settings/cache/", main: (context) => <CachePage pageContext={context} /> }
  ]
  const routes = pages.map((page) => {
    return <Route key={page.path} path={page.path + "*"} element={
        <HeaderTitleProvider apiContext={context}>
          {page.main(context)}
        </HeaderTitleProvider>
      }/>;
  });

  // 施工管理はモック準拠の area 中心2タブ(施工箇所/材料追跡)に再構成。
  // 在庫/数量計画は上の独立ルート(stock/ , quantity-plan/)へ移設済み。
  return [...routes, <Route key="default" path={"*"} element={<Navigate to="/" replace />} />];
}
